export default "__VITE_ASSET__C4m3mHKB__"